import RestModel from './RestModel';
import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const resourceName = 'backgrounds';

export default {
    create: resource => RestModel.create(resourceName, removeExtraSubFieldsHelper(resource, ['picture'])),

    edit: resource => RestModel.edit(resourceName, removeExtraSubFieldsHelper(resource, ['picture'])),

    list: () => RestModel.list(resourceName),

    read: id => RestModel.read(resourceName, id),

    remove: id => RestModel.remove(resourceName, id),
};
